import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import _ from 'lodash';
import { BehaviorSubject, Observable, isObservable } from 'rxjs';
import { map, take } from 'rxjs/operators';

@Pipe({
   name: 'i18nSort',
})
export class I18nSortPipe implements PipeTransform {
   constructor(private translateService: TranslateService) {}

   private unwrapIfObservable(value: string | Observable<string>): string {
      if (!isObservable(value)) {
         return value;
      }

      const subject = new BehaviorSubject('');
      value.pipe(take(1)).subscribe(subject);
      return subject.getValue();
   }

   private getKeyFromFunction<T>(item: T, keyFunction: string, ...functionArgs: any[]): string {
      return this.unwrapIfObservable(item[keyFunction](...functionArgs));
   }

   transform<T>(items$: Observable<T[]>, keyProperty: string, ...keyFunctionArgs: any[]): Observable<T[]> {
      if (_.isNil(items$)) {
         return null;
      }

      return items$.pipe(
         map((items) => {
            return _(items)
               .map((item) => {
                  return {
                     ...item,
                     __i18nSortKey: _.isFunction(items[0][keyProperty])
                        ? this.translateService.instant(this.getKeyFromFunction<T>(item, keyProperty, ...keyFunctionArgs))
                        : this.translateService.instant(this.unwrapIfObservable(item[keyProperty])),
                  };
               })
               .orderBy('__i18nSortKey', 'asc')
               .value();
         })
      );
   }
}
